/* esm.sh - @emotion/memoize@0.9.0 */
function u(t){var n=Object.create(null);return function(e){return n[e]===void 0&&(n[e]=t(e)),n[e]}}export{u as default};
//# sourceMappingURL=memoize.mjs.map